<template>
    <div class="misc-wrapper">
        <b-link class="brand-logo">
            <b-img id="top-bar-logo" :src="`${staticAssetEndpoint}/images/logos/saysimple-dark.svg`" />
        </b-link>

        <div class="misc-inner p-2 p-sm-3">
            <div class="w-100 text-center">
                <h2 class="mb-1">{{ $t("not-authorized") }}</h2>
                <p class="mb-2">{{ $t("failed-login") }}</p>
                <b-button class="mb-1 btn-sm-block" variant="primary" @click="logout">
                    {{ $t("try-again") }}
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import { BLink, BImg, BButton } from "bootstrap-vue";

export default {
    components: {
        BLink,
        BImg,
        BButton,
    },
    data() {
        return {
            staticAssetEndpoint: process.env.VUE_APP_MFE_STATIC_ENDPOINT,
        };
    },
    computed: {},
    methods: {
        logout() {
            this.$auth.logout({
                returnTo: window.location.origin,
            });
        },
    },
};
</script>

<style lang="scss">
@import "~@core/scss/vue/pages/page-misc.scss";
</style>
